import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import type { SubscriptionRow } from "./types";
import { AdminDataTableShell } from "../ui";

function StatutBadge(props: { tone: SubscriptionRow["statutTone"]; label: string }): React.JSX.Element {
  const { tone, label } = props;
  const cls =
    tone === "green"
      ? "bg-emerald-500/15 text-emerald-200 ring-emerald-500/25"
      : tone === "orange"
        ? "bg-amber-500/15 text-amber-100 ring-amber-500/25"
        : tone === "red"
          ? "bg-red-500/15 text-red-100 ring-red-500/25"
          : "bg-slate-600/40 text-slate-200 ring-slate-500/30";
  return (
    <span className={`inline-flex rounded-full px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide ring-1 ${cls}`}>
      {label}
    </span>
  );
}

function wireSoon(): void {
  toast.info("Module à brancher — disponible après branchement métier.", {
    position: "bottom-center",
  });
}

export function SubscriptionTable(props: { rows: SubscriptionRow[] }): React.JSX.Element {
  const { rows } = props;
  const navigate = useNavigate();

  return (
    <AdminDataTableShell>
      <div className="overflow-x-auto">
        <table className="min-w-[1100px] w-full text-sm">
          <thead>
            <tr className="border-b border-slate-800 bg-slate-950/80 text-left text-[10px] font-bold uppercase tracking-wider text-slate-500">
              <th className="whitespace-nowrap px-4 py-3">Client</th>
              <th className="whitespace-nowrap px-4 py-3">Type client</th>
              <th className="whitespace-nowrap px-4 py-3">Plan / Catégorie</th>
              <th className="whitespace-nowrap px-4 py-3">Fréquence</th>
              <th className="whitespace-nowrap px-4 py-3">Prix</th>
              <th className="whitespace-nowrap px-4 py-3">Passages prévus</th>
              <th className="whitespace-nowrap px-4 py-3">Dotations</th>
              <th className="whitespace-nowrap px-4 py-3">Statut contrat</th>
              <th className="whitespace-nowrap px-4 py-3">Dette / solde</th>
              <th className="whitespace-nowrap px-4 py-3">Prochain passage</th>
              <th className="whitespace-nowrap px-4 py-3 text-right">Actions</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.contratId} className="border-b border-slate-800/80 hover:bg-slate-900/60">
                <td className="max-w-[14rem] px-4 py-3 font-medium text-white">{r.clientDisplay}</td>
                <td className="whitespace-nowrap px-4 py-3 text-slate-300">{r.clientTypeLabel}</td>
                <td className="max-w-[12rem] px-4 py-3 text-slate-200">{r.planLabel}</td>
                <td className="whitespace-nowrap px-4 py-3 text-slate-300">{r.frequence}</td>
                <td className="whitespace-nowrap px-4 py-3 tabular-nums text-slate-100">{r.prixLabel}</td>
                <td className="whitespace-nowrap px-4 py-3 tabular-nums text-slate-300">{r.passagesPrevusLabel}</td>
                <td className="max-w-[10rem] px-4 py-3 text-xs text-slate-400">{r.dotationsLabel}</td>
                <td className="whitespace-nowrap px-4 py-3">
                  <StatutBadge tone={r.statutTone} label={r.statutContrat} />
                </td>
                <td className="whitespace-nowrap px-4 py-3 tabular-nums text-slate-200">{r.detteLabel}</td>
                <td className="whitespace-nowrap px-4 py-3 text-slate-300">{r.prochainPassageLabel}</td>
                <td className="px-4 py-3">
                  <div className="flex flex-wrap justify-end gap-1">
                    <button
                      type="button"
                      className="rounded-lg border border-slate-700 bg-slate-950/60 px-2 py-1 text-[11px] font-medium text-slate-200 hover:bg-slate-800"
                      onClick={() => navigate(`/admin/clients/${r.clientId}`)}
                    >
                      Voir détail
                    </button>
                    <button
                      type="button"
                      className="rounded-lg border border-slate-700 bg-slate-950/60 px-2 py-1 text-[11px] font-medium text-slate-200 hover:bg-slate-800"
                      onClick={() => navigate(`/admin/clients/${r.clientId}`)}
                    >
                      Modifier
                    </button>
                    <button
                      type="button"
                      className="rounded-lg border border-slate-700 bg-slate-950/60 px-2 py-1 text-[11px] font-medium text-slate-400 hover:bg-slate-800"
                      onClick={() => wireSoon()}
                    >
                      Planifier
                    </button>
                    <button
                      type="button"
                      className="rounded-lg border border-slate-700 bg-slate-950/60 px-2 py-1 text-[11px] font-medium text-slate-400 hover:bg-slate-800"
                      onClick={() => wireSoon()}
                    >
                      Dotations
                    </button>
                    <button
                      type="button"
                      className="rounded-lg border border-emerald-500/25 bg-emerald-500/10 px-2 py-1 text-[11px] font-semibold text-emerald-200 hover:bg-emerald-500/15"
                      onClick={() => navigate("/admin/finance/factures")}
                    >
                      Facturer
                    </button>
                    <button
                      type="button"
                      className="rounded-lg border border-red-500/25 bg-red-500/10 px-2 py-1 text-[11px] font-medium text-red-200 hover:bg-red-500/15"
                      onClick={() => wireSoon()}
                    >
                      Suspendre / Résilier
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </AdminDataTableShell>
  );
}
